module.exports = __webpack_public_path__ + "static/media/ma3.1601fe4c.png";